import {
  CalendarFiveIcon,
  CalendarFourIcon,
  ChatIcon,
  DollarIcon,
  FileXMarkIcon,
  PhoneIcon
} from '@repo/ui/icons'

import { StatusOption } from '../../utils'
import { StaffApplicationStatusEnum } from './staff-application-status.enum'

export type StaffApplicationKanbanStatus =
  | Extract<
      StaffApplicationStatusEnum,
      | 'TO_BE_CONTACTED'
      | 'FIRST_CONTACT_ESTABLISHED'
      | 'SECOND_CONTACT_ESTABLISHED'
      | 'THIRD_CONTACT_ESTABLISHED'
      | 'CLASSIFIED'
      | 'INTERVIEW_SCHEDULED'
      | 'INTERVIEW_DONE'
    >
  | 'PAID'

export interface StaffApplicationKanbanStatusOptions extends StatusOption {
  icon: React.FC
}

/**
 * Please do not change the order since it is used in the kanban
 */
export const staffApplicationKanbanStatusMapping: Record<
  StaffApplicationKanbanStatus,
  StaffApplicationKanbanStatusOptions
> = {
  TO_BE_CONTACTED: {
    label: 'À contacter',
    icon: PhoneIcon
  },
  FIRST_CONTACT_ESTABLISHED: {
    label: 'Premier contact établi',
    icon: ChatIcon
  },
  SECOND_CONTACT_ESTABLISHED: {
    label: 'Deuxième contact établi',
    icon: ChatIcon
  },
  THIRD_CONTACT_ESTABLISHED: {
    label: 'Troisième contact établi',
    icon: ChatIcon
  },
  CLASSIFIED: {
    label: 'Classé sans suite',
    icon: FileXMarkIcon
  },
  INTERVIEW_SCHEDULED: {
    label: 'Entretien planifié',
    icon: CalendarFourIcon
  },
  INTERVIEW_DONE: {
    label: 'Entretien terminé',
    icon: CalendarFiveIcon
  },
  PAID: {
    label: 'Payé',
    icon: DollarIcon
  }
}
